import * as React from "react";

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={64} height={64} viewBox="0 0 64 64" {...props}>
      {/* Outer Chip Body */}
      <rect x="8" y="8" width="48" height="48" rx="8" fill="#9ec3ff" />

      {/* Inner Chip with Split Background */}
      <rect x="16" y="16" width="32" height="32" rx="4" fill="#6c7ecf" />
      <path d="M16 16h32v32H16z" fill="rgba(0, 0, 0, 0.1)" />

      {/* AI Text */}
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dominantBaseline="middle"
        fontFamily="Arial, sans-serif"
        fontWeight="bold"
        fontSize="20"
        fill="white"
      >
        AI
      </text>

      {/* Chip Pins */}
      {[...Array(4)].map((_, i) => (
        <>
          {/* Top pins */}
          <rect x={12 + i * 12} y="2" width="4" height="6" rx="1" fill="#6c7ecf" />
          {/* Bottom pins */}
          <rect x={12 + i * 12} y="56" width="4" height="6" rx="1" fill="#6c7ecf" />
          {/* Left pins */}
          <rect x="2" y={12 + i * 12} width="6" height="4" rx="1" fill="#6c7ecf" />
          {/* Right pins */}
          <rect x="56" y={12 + i * 12} width="6" height="4" rx="1" fill="#6c7ecf" />
        </>
      ))}
    </svg>
  );
}

export default SvgComponent;
